import _isNil from 'lodash/isNil';
import getSelectedDealerIdFromLS from './getSelectedDealerIdFromLS';
export var getDefaultMainSiteId = function getDefaultMainSiteId(dealerId) {
  return _isNil(dealerId) ? "-1_".concat(getSelectedDealerIdFromLS()) : "-1_".concat(dealerId);
};